import type {
  DeleteBoardsUserRolesRequestType,
  DeleteBoardsUserRolesResponseType,
} from 'entities/document/api/types';
import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const deleteBoardsUserRoles = async ({
  boardId,
  ...params
}: DeleteBoardsUserRolesRequestType) => {
  const query = stringifyUrlQuery(params);

  const url = `/api/v2/boards/${boardId}/user-roles${query}`;
  const result =
    await apiAuthClient.delete<DeleteBoardsUserRolesResponseType>(url);

  return result.data;
};
